'use strict'

module.exports = class PageSpinner
  constructor: ({@el, @topMargin} = {}) ->
    @options = Object.assign {}, LOADING_OPTIONS
    @isRunning = false

  render: ->
    return if @isRunning
    @isRunning = true
    @options.topMargin = @topMargin
    @_insertSpinner()
    @start()

  close: ->
    return unless @isRunning
    @isRunning = false
    @stop()

  startRunning: ->
    @isRunning = true

  stopRunning: ->
    @isRunning = false

  LOADING_OPTIONS =
    fullscreenOverlay: false
    label: 'Loading...'

  start: ->
    # adjust the spinner to fit the page
    scrollTopDistance = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
    if @options.topMargin?
      topMargin = @options.topMargin
    else if scrollTopDistance > 200
      topMargin = @options.baseTop + scrollTopDistance - 250
    else
      topMargin = @options.baseTop + 100

    @spinnerBack.style.top = topMargin
    @overlay.style.display = 'inline-block'
    document.querySelector(@el)

  _insertSpinner: ->
    unless document.querySelector(@el)?.querySelector('#load-overlay')
      @overlay = document.createElement('div')
      @overlay.id = 'load-overlay'

      @spinnerBack = document.createElement('div')
      @spinnerBack.id = 'spinner-back'

      @spinner = document.createElement('div')
      @spinner.id = 'spinner'
      @spinner.classList.add 'icon-g-loader'

      @spinnerBack.appendChild @spinner
      @overlay.appendChild @spinnerBack

      document.querySelector(@el).appendChild @overlay

  stop: ->
    @overlay.style.display = 'none'
    document.querySelector(@el)
